import '@babel/polyfill/noConflict';
import './vendor/modernizr';
import 'intersection-observer';

import 'root-consent';
// import 'root-consent/dist/js/plugins/google-analytics'

import GoogleMapsApiLoader from 'google-maps-api-loader';
import objectFitImages from 'object-fit-images';

// Polyfill for missing forEach in IE11
if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (var i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

import { AnimateObserver } from './lib/animate-observer';
import { Slider } from './lib/slider';
import { Sticky } from './lib/sticky';
import { Trigger } from './lib/trigger';
import { Pop } from './lib/pop';
import { LazyLoad } from './lib/lazy-load';
import { Maps } from './lib/maps';
import { Counter } from './lib/counter';
import { Interstitial } from './lib/ininterstitial';

objectFitImages();

const animate = new AnimateObserver();
animate.init();

const slider = new Slider();
slider.init();

const sticky = new Sticky();
sticky.init();

// Pull out menu
const trigger = new Trigger();
trigger.init();

// Experience pop-up menu
const pop = new Pop();
pop.init();

const lazy = new LazyLoad();
lazy.init();

const maps = new Maps();
maps.init();

const counter = new Counter();
counter.init();

const interestial = new Interstitial();
interestial.init();

GoogleMapsApiLoader( {
    libraries: [],
    apiKey: 'AIzaSyDpq1w2-eKhot88BGUIprIUToGXBkA4AQQ'
} ).then( googleApi => {
    maps.generate( googleApi );
} );

const Consent = rootConsent( 'body', {
    messageText: 'This site uses cookies to help us manage and improve the website and to analyse how visitors use our site. By continuing to use the website, you are agreeing to our use of cookies. For further information about cookies, including about how to change your browser settings to no longer accept cookies, please view our <a href="/cookie-notice">Cookie Policy</a>.',
    approveLabel: 'OK',
    delay: 500,
    alwaysApproved: true
} );

